package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.model.CharacterSheet
import fr.manyverse.app.domain.repository.CharacterRepository
import fr.manyverse.app.domain.validation.CharacterSheetValidator

class UpdateCharacterSheetUseCase(
    private val characterRepository: CharacterRepository
) {
    suspend operator fun invoke(
        characterId: String,
        sheet: CharacterSheet
    ): Result<Character> {
        if (characterId.isBlank()) {
            return Result.failure(ValidationError("Character id cannot be empty"))
        }

        sheet.gauges.forEach { gauge ->
            CharacterSheetValidator
                .validateGauge(gauge.label, gauge.min, gauge.max, gauge.increment, gauge.current)
                .onFailure { return Result.failure(it) }
        }
        sheet.characteristics.forEach { characteristic ->
            CharacterSheetValidator
                .validateCharacteristic(
                    characteristic.label,
                    characteristic.value,
                    characteristic.description
                )
                .onFailure { return Result.failure(it) }
        }
        sheet.skills.forEach { skill ->
            CharacterSheetValidator.validateSkill(skill.label, skill.description)
                .onFailure { return Result.failure(it) }
        }
        sheet.powers.forEach { power ->
            CharacterSheetValidator.validatePower(power.label, power.description)
                .onFailure { return Result.failure(it) }
        }

        return characterRepository.updateCharacterSheet(characterId, sheet)
    }
}
